/**
 * @generated SignedSource<<b3cc80decdc9303eb169141d102221ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderEmbedded$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_jqlBuilder_JQLBuilder">;
  readonly " $fragmentType": "JQLBuilderEmbedded";
};
export type JQLBuilderEmbedded$key = {
  readonly " $data"?: JQLBuilderEmbedded$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderEmbedded">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JQLBuilderEmbedded",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_jqlBuilder_JQLBuilder"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "4071ebb322370be0c57c356b3c841beb";

export default node;
